/*
*
* File JS componente Icon Interactive
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//
import './icon-interactive.scss';

//--------------------------------------------------------------------//

const icontInteractive = () => {
    let context = document.querySelectorAll('.icon-interactive');
    if(!context.length) return;

    context.forEach(element => {
        const cards = element.querySelectorAll('.icon-interactive__card');
        if(!cards.length) return;

        cards.forEach(card => {
            const desc = card.querySelector('.icon-interactive__desc');

            if(!desc) return;

            card.addEventListener('click', (e) => {
                card.classList.toggle('open');
            })
        });

    });
}

export default icontInteractive;
